import styled from 'styled-components';

export const HeaderDiv = styled.div`
  display: inline-block;
  width: 25%;
  height: 35px;
  border: 1px solid #e0e0e0;
  line-height: 35px;
  padding-left: 5px;
  border-bottom: 2px solid #e0e0e0;
`;

export const SelectButton = styled.div`
  position: relative;
  text-align: ${(props) => (props.color ? 'center' : 'left')};
  background: ${(props) => props.color || 'rgba(255, 255, 255, 0)'};
  color: ${(props) => (props.color ? '#ffffff' : '#000000')};
  height: 25px;
  width: 70%;
  top: 4px;
  line-height: 25px;
  cursor: ${(props) => (props.color ? 'pointer' : 'auto')};
  ${(props) =>
    props.color
      ? `
    :hover{
      background:rgba(33, 150, 243, 0.9);
    }`
      : ''};
  border-radius: 3px;
`;
